<template>
  <div
    class="flex items-center overflow-y-auto rounded-b-r2 border border-solid border-t-action bg-neutral-50 shadow-md"
    :class="{
      'flex-wrap': (brands?.length ?? 0) > 9,
      'flex-col': (brands?.length ?? 0) <= 9,
    }"
  >
    <MenuItem
      v-for="brand in brands"
      class="w-[150px]"
      v-bind="brand"
      @click="$emit('select', brand.q_key, brand.value)"
    />
  </div>
</template>

<script setup lang="ts">
import type { NavItemProps } from "~/types/schemas/Informative/Molecule/NavItem";
import MenuItem from "~/components/features/InformativePages/Atom/MenuItem.vue";

defineEmits<{
  select: [key: string, value: string];
}>();

defineProps<{
  brands?: NavItemProps[];
}>();
</script>
